<!--模板-->
<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<!--js-->
<script>

import BACKEND_URL from '@/global/global';
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    attachEvents() {
      global.vbus.$on('global.$Message.show', msg => {
        this.$Message.error({
          content: msg,
          duration: 4
        });
      });
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
  created() {
    this.attachEvents();
    // this.$store.dispatch('updateUserInfo')
  },
  mounted() {
    let backendUrl = this.BACKEND_URL;
    this.$api['ql/getSysbaseinfo']().then(data => {
      if (data != null) {
        $('#titleImg').attr('href', data.window);
        $('title').html(data.windowTitle);
      }
    });
    document.body.className = localStorage.getItem('app');
    if (localStorage.getItem('app') === null) {
      document.body.className = 'classic';
    }
  }

};
</script>

<!--样式-->
<style lang="less">
  @import './static/css/app.less';
</style>
